export const setAccessUser = 'setAccessUser'
export const setAccessUsers = 'setAccessUsers'
export const updateAccessUser = 'updateAccessUser'
export const clearAccessUsers = 'clearAccessUsers'



// WEBPACK FOOTER //
// ./src/app/pages/access_users/vuex/mutations-types.js